import React from 'react';
import './PageTemplate.css';

const PageTemplate = ({ 
  title, 
  subtitle, 
  breadcrumb, 
  heroImage, 
  children,
  className = ""
}) => {
  return (
    <div className={`page-template ${className}`}>
      <section className="page-hero">
        <div className="page-hero-background">
          <div className="page-hero-overlay"></div>
        </div>
        <div className="container">
          <div className="page-hero-content">
            <div className="breadcrumb">
              <span>Home</span>
              {breadcrumb && (
                <>
                  <i className="fas fa-chevron-right"></i>
                  <span>{breadcrumb}</span>
                </>
              )}
            </div>
            <h1>{title}</h1>
            {subtitle && <p className="page-subtitle">{subtitle}</p>}
          </div>
        </div>
      </section>
      
      <section className="page-content">
        <div className="container">
          {children}
        </div>
      </section>
    </div>
  );
};

export default PageTemplate; 